import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { rolesQueries } from '@/services/rolesPrivilege/roles.queries';
import { useSearch } from '@tanstack/react-router';

export const useRoleType = (roleType: 'admin' | 'club' | 'affiliate' | 'customer', roleTypeId: string) => {
  const { sort, q, page, fetch } = useSearch({ from: '/(app)/users/roles/' });
  const { data, isLoading } = useQuery({
    ...rolesQueries.table(roleType, roleTypeId, {
      row: page,
      fetch: fetch,
      search: q ?? '',
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data ?? [], sort),
    }),
  });

  return { rolesList: data?.data || [], isLoading, meta: data?.meta?.pagination ?? defaultMeta };
};
